const collectionGetters = {

  getTitle(collection) {
    return collection?.banner_title ?? null;
  },

  getSubtitle(collection) {
    return collection?.banner_subtitle ?? null;
  },

  getButtonText(collection) {
    return collection?.banner_button_text ?? null;
  },

  hasVideo(collection) {
    return Boolean(collection?.content_video_desktop_url || collection?.content_video_mobile_url);
  },

  getMobileVideo(collection) {
    return collection?.content_video_mobile_url ?? null;
  },

  getMobileVideoPoster(collection) {
    return collection?.content_video_mobile_preview_url ?? null;
  },

  getDesktopVideo(collection) {
    return collection?.content_video_desktop_url ?? null;
  },

  getDesktopVideoPoster(collection) {
    return collection?.content_video_desktop_preview_url ?? null;
  },

  getMobileBannerImage(collection) {
    return collection?.banner_image_mobile_url ?? null;
  },

  getDesktopBannerImage(collection) {
    return collection?.banner_image_desktop_url ?? null;
  },

  getContent(collection) {
    return collection?.content ?? null;
  },

  getMobileContentImage(collection) {
    return collection?.content_image_mobile_url ?? null;
  },

  getDesktopContentImage(collection) {
    return collection?.content_image_desktop_url ?? null;
  },

  getType(collection) {
    return collection?.type_code ?? null;
  },

  getCategoryUid(collection) {
    return collection?.category_uid ?? null;
  },
};

export default collectionGetters;
